"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
exports.default = vue_1.default.extend({
    methods: {
        // 登录
        jumpLogin() {
            const { common: { behavior: { runBehaviour } } } = require('@futuweb/fego-render');
            runBehaviour(this, {
                type: 'login',
                value: location.href,
                withQuery: true
            });
        }
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29tbW9uLnZ1ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkNvbW1vbi52dWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0Esc0RBQXNCO0FBQ3RCLGtCQUFlLGFBQUcsQ0FBQyxNQUFNLENBQUM7SUFDdEIsT0FBTyxFQUFFO1FBQ0wsS0FBSztRQUNMLFNBQVM7WUFDTCxNQUFNLEVBQ0YsTUFBTSxFQUFFLEVBQ0osUUFBUSxFQUFFLEVBQUUsWUFBWSxFQUFFLEVBQzdCLEVBQ0osR0FBRyxPQUFPLENBQUMsc0JBQXNCLENBQUMsQ0FBQztZQUNwQyxZQUFZLENBQUMsSUFBSSxFQUFFO2dCQUNmLElBQUksRUFBRSxPQUFPO2dCQUNiLEtBQUssRUFBRSxRQUFRLENBQUMsSUFBSTtnQkFDcEIsU0FBUyxFQUFFLElBQUk7YUFDbEIsQ0FBQyxDQUFDO1FBQ1AsQ0FBQztLQUNKO0NBQ0osQ0FBQyxDQUFDIn0=